/** Politique de confidentialité versionnée (loi n°001/2011 Gabon). */

export const PRIVACY_DATA_CATEGORIES = [
  { code: 'identite', label: 'Identité' },
  { code: 'coordonnees', label: 'Coordonnées' },
  { code: 'contractuel', label: 'Données contractuelles' },
  { code: 'salarial', label: 'Données salariales' },
  { code: 'bancaire', label: 'Données bancaires' },
  { code: 'sante', label: 'Données de santé (arrêts maladie)' },
  { code: 'disciplinaire', label: 'Données disciplinaires' },
] as const;

export type PrivacyDataCategoryCode = (typeof PRIVACY_DATA_CATEGORIES)[number]['code'];

export interface PrivacyRetentionRule {
  category: PrivacyDataCategoryCode | string;
  duration_label: string;
  legal_basis: string;
}

export interface PrivacyPolicy {
  id: string;
  version: string;
  effective_date: string;
  content: string;
  data_categories: string[];
  retention_rules: PrivacyRetentionRule[];
  dpo_name?: string;
  dpo_email?: string;
  dpo_phone?: string;
  is_active: boolean;
  created_by: string;
  created_at: string;
}

export function activePrivacyPolicy(policies: readonly PrivacyPolicy[]): PrivacyPolicy | null {
  return policies.find((p) => p.is_active) ?? null;
}

export function privacyPolicySummary(policy: PrivacyPolicy | null): string {
  if (!policy) return 'Aucune politique de confidentialité publiée.';
  const cats = policy.data_categories.length
    ? policy.data_categories.join(', ')
    : 'non précisées';
  return `Version ${policy.version} (entrée en vigueur ${policy.effective_date}). Catégories : ${cats}.`;
}
